// The single market test, so the US exception lives in one place rather than
// once per thing that varies by market. Case-insensitive on purpose: callers
// uppercase for the imperial-unit lookups in measurementConfig.ts, and a raw
// "us" must not fall through to the default meant for everywhere else.
export function isUS(countryCode: string | null | undefined): boolean {
  return countryCode?.toUpperCase() === "US";
}

// Echo-2 is the cardio/* modality, which has no FDA clearance in the US.
// Written as an allowlist rather than "not the US" on purpose: the country
// arrives with the visit, and an unknown market answered as "available" would
// draw the row in a US clinic until the query lands, or for the whole visit if
// it never does. Both the scan-progress row and the checkout warning read this,
// so neither can name a scan the other hides.
export function isEcho2Market(countryCode: string | null | undefined): boolean {
  const named = countryCode != null && countryCode.trim() !== "";
  return named && !isUS(countryCode);
}
